<template>
  <div>
    <section class="section">
      <div class="container has-text-centered">
        <img width="25%" src="@/assets/logo2.png" alt="Logo" />
      </div>
      <br />
      <div class="container" style='padding-right: 45px; padding-left: 45px;'>
        <div class="box">
          <div v-show="pase === 0" style='padding-right: 25%; padding-left: 25%;'>
            <center>
              <h1 class="title has-text-dark">
                Mytho - Cultura Organizacional
              </h1>
              <h2 class="subtitle has-text-dark is-3">
                Haciendo la diferencia
              </h2>
            </center>
            <div v-show='[1,2].includes(parseInt(employeeresponded.quiz))' style='text-align: justify'>
              <br />
              <p>
                <strong>¡Hola! {{ employeeresponded.nombre }}</strong>
                <br><br>
                Esta encuesta busca identificar cómo es la organización actualmente y así poder desarrollar planes para llegar a ser como desea.
                <br />
                Antes de que inicies, es importante que sepas que tu participación es voluntaria, no se reportarán resultados individuales y tus respuestas se manejarán de manera confidencial y según la normatividad vigente en Colombia (en especial la Ley 1581 de 2012). No hay respuestas correctas o incorrectas, responde de acuerdo con tu conocimiento de la organización. Concéntrate en el diligenciamiento y no salgas hasta terminar.
              </p>
              <br/>
              <p>
                *Estos datos podrán ser usados por Siete para investigación, siempre manteniendo la confidencialidad de los mismos.
              </p>
              <br />
            </div>

            <div v-show='parseInt(employeeresponded.quiz) === 3' style='text-align: justify' >
              <br />
              <p>
                <strong>¡Hola! {{ employeeresponded.nombre }}</strong>
                <br><br>
                Esta encuesta busca identificar la cultura actual de la organización y la que debe desarrollarse para lograr los retos propuestos para los próximos años.
                <br />
                Antes de que inicies, es importante que sepas que tu participación es voluntaria, no se reportarán resultados individuales y tus respuestas se manejarán de manera confidencial y según la normatividad vigente en Colombia (en especial la Ley 1581 de 2012). No hay respuestas correctas o incorrectas, responde de acuerdo con tu conocimiento de la organización. Concéntrate en el diligenciamiento y no salgas hasta terminar.
              </p>
              <br/>
              <p>
                *Estos datos podrán ser usados por Siete para investigación, siempre manteniendo la confidencialidad de los mismos.
              </p>
              <br />
            </div>

            <div class="control">
              <div class="field">
                <input
                  class="is-checkradio is-dark"
                  type="radio"
                  id="agreeyes"
                  :value="true"
                  v-model="responses.agree"
                />
                <label for="agreeyes" class="is-capitalized">Sí</label>
                <input
                  class="is-checkradio is-dark"
                  type="radio"
                  id="agreeno"
                  :value="false"
                  v-model="responses.agree"
                />
                <label for="agreeno" class="is-capitalized">No</label>
              </div>
            </div>
            <br />
            <button class="button is-dark" @click="nextpase()">
              Siguiente
            </button>
          </div>
          <div v-show="pase === 1">
            <center>
              <h1 class="title has-text-dark">Instrucciones</h1>
            </center>
            <br />
            <p>
              Aquí encontrarás grupos de cuatro características (A, B, C, D). Tienes 100 puntos para distribuir entre ellas, asignando más puntos a la característica que mejor describa a tu organización.
              <br />
              Por ejemplo, si crees que la característica A describe muy bien a tu organización, puedes asignarle 55 puntos, si B y C la describen un poco puedes darles 20 puntos a cada una, y a la D, 5 puntos porque describe muy poco a tu organización. Esto nos da un total de 100 puntos.
              <br />
              Siempre la suma de puntos debe ser igual a 100.
            </p>
            <br />
            <button class="button is-dark" @click="nextpase()">
              Siguiente
            </button>
          </div>
          <div v-show="pase === 2">
            <div>
              <h1 class="title has-text-dark">
                {{ questions[section].title }}
              </h1>
              <h2 class="subtitle is-5 has-text-dark">
                {{ questions[section].subtitle }}
              </h2>
              <br />
              <div>
                <h1 class="title is-4">
                  {{ questions[section].grupos[grupo].text }}
                </h1>
                <div class="columns">
                  <div class="column is-10">
                    {{ questions[section].grupos[grupo].questions[0].text }}
                  </div>
                  <div class="column">
                    <div class="field">
                      <div class="control">
                        <input
                          @blur="
                            blurFunction(
                              questions[section].grupos[grupo].questions[0]
                                .codigo
                            )
                          "
                          class="input"
                          type="number"
                          v-model="
                            responses[
                              questions[section].grupos[grupo].questions[0]
                                .codigo
                            ]
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns has-background-light">
                  <div class="column is-10">
                    {{ questions[section].grupos[grupo].questions[1].text }}
                  </div>
                  <div class="column">
                    <div class="field">
                      <div class="control">
                        <input
                          @blur="
                            blurFunction(
                              questions[section].grupos[grupo].questions[1]
                                .codigo
                            )
                          "
                          class="input"
                          type="number"
                          v-model="
                            responses[
                              questions[section].grupos[grupo].questions[1]
                                .codigo
                            ]
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-10">
                    {{ questions[section].grupos[grupo].questions[2].text }}
                  </div>
                  <div class="column">
                    <div class="field">
                      <div class="control">
                        <input
                          @blur="
                            blurFunction(
                              questions[section].grupos[grupo].questions[2]
                                .codigo
                            )
                          "
                          class="input"
                          type="number"
                          v-model="
                            responses[
                              questions[section].grupos[grupo].questions[2]
                                .codigo
                            ]
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns has-background-light">
                  <div class="column is-10">
                    {{ questions[section].grupos[grupo].questions[3].text }}
                  </div>
                  <div class="column">
                    <div class="field">
                      <div class="control">
                        <input
                          @blur="
                            blurFunction(
                              questions[section].grupos[grupo].questions[3]
                                .codigo
                            )
                          "
                          class="input"
                          type="number"
                          v-model="
                            responses[
                              questions[section].grupos[grupo].questions[3]
                                .codigo
                            ]
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-10">
                    <strong>Total</strong>
                    <small>Resta {{ (100 - total) | number() }}</small>
                  </div>
                  <div class="column">
                    <div class="field">
                      <div class="control">
                        <input
                          class="input"
                          type="number"
                          v-model="total"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  class="button is-dark"
                  @click="nextquestion()"
                  :disabled="validatotal"
                >
                  {{grupo === 5 && parseInt(this.employeeresponded.quiz) === 1 ? 'Finalizar' : 'Siguiente'}}
                </button>
              </div>
            </div>
          </div>
          <div v-show="pase === 3">
            <h1 class="title has-text-dark has-text-centered">Mi empresa hoy es…</h1>
            <h2 class="subtitle has-text-dark is-5">
              Piensa si alguien te pregunta ¿Cómo es hoy tu organización? qué le responderías.
            </h2>
            <p>
              A continuación, encontrarás cinco (5) campos de texto. Simplemente escribe las características que se te ocurran primero y que describan mejor a tu organización actualmente, hasta completar cinco (5) frases cortas.
            </p>
            <br />
            <div class="columns has-background-light">
              <div class="column is-4">1. Mi empresa es:</div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input" type="text" v-model="responses.mes1" />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">2. Mi empresa es:</div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input" type="text" v-model="responses.mes2" />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns has-background-light">
              <div class="column is-4">3. Mi empresa es:</div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input" type="text" v-model="responses.mes3" />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">4. Mi empresa es:</div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input" type="text" v-model="responses.mes4" />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns has-background-light">
              <div class="column is-4">5. Mi empresa es:</div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input" type="text" v-model="responses.mes5" />
                  </div>
                </div>
              </div>
            </div>
            <button
              v-show="parseInt(employeeresponded.quiz) === 3"
              class="button is-dark"
              @click="nextpase()"
            >
              Siguiente
            </button>
            <button
              v-show="parseInt(employeeresponded.quiz) === 2"
              class="button is-dark"
              @click="nextpase1()"
            >
              Siguiente
            </button>
          </div>
          <div v-show="pase === 4">
            <h1 class="title has-text-dark has-text-centered">Mi empresa debería ser…</h1>
            <h2 class="subtitle has-text-dark is-5">
              Ahora piensa en el futuro. Las siguientes cinco (5) frases están dirigidas a describir cómo debería ser la empresa para ser exitosa (5 años).
            </h2>
            <p>
              Si en este momento la empresa tiene características que se deben
              mantener, también pueden ser incluidas.
            </p>
            <br />
            <div class="columns has-background-light">
              <div class="column is-4">1. Mi empresa debería ser:</div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input" type="text" v-model="responses.mds1" />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">2. Mi empresa debería ser:</div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input" type="text" v-model="responses.mds2" />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns has-background-light">
              <div class="column is-4">3. Mi empresa debería ser:</div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input" type="text" v-model="responses.mds3" />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">4. Mi empresa debería ser:</div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input" type="text" v-model="responses.mds4" />
                  </div>
                </div>
              </div>
            </div>
            <div class="columns has-background-light">
              <div class="column is-4">5. Mi empresa debería ser:</div>
              <div class="column">
                <div class="field">
                  <div class="control">
                    <input class="input" type="text" v-model="responses.mds5" />
                  </div>
                </div>
              </div>
            </div>
            <div class="buttons">
              <button class="button is-dark" @click="backpase(true)">
                Volver
              </button>
              <button class="button is-dark" @click="nextpase(true)">
                Finalizar
              </button>
            </div>
          </div>
          <div v-show="pase === 5">
            <center>
              <h1 class="title has-text-dark">FINALIZAR</h1>
              <h2 class="subtitle has-text-dark is-3">
                Muchas gracias por aportar al desarrollo de tu organización.
                <br />
                ¡Que tengas un lindo día!
              </h2>
            </center>
          </div>
          <div v-show='pase === 6'>
            <div>
              <h1 class='has-text-centered has-text-weight-bold is-dark'>Esta encuesta no existe</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services-public";
export default {
  data() {
    return {
      employeeresponded: {},
      responses: {
        agree: true,
        ClCd: 0,
        MeCd: 0,
        AdCd: 0,
        JeCd: 0,
        JeLo: 0,
        ClLo: 0,
        MeLo: 0,
        AdLo: 0,
        AdAp: 0,
        JeAp: 0,
        MeAp: 0,
        ClAp: 0,
        JeUne: 0,
        AdUne: 0,
        ClUne: 0,
        MeUne: 0,
        MeEe: 0,
        ClEe: 0,
        JeEe: 0,
        AdEe: 0,
        MeCe: 0,
        AdCe: 0,
        ClCe: 0,
        JeCe: 0,
        ClCd2: 0,
        MeCd2: 0,
        AdCd2: 0,
        JeCd2: 0,
        JeLo2: 0,
        ClLo2: 0,
        MeLo2: 0,
        AdLo2: 0,
        AdAp2: 0,
        JeAp2: 0,
        MeAp2: 0,
        ClAp2: 0,
        JeUne2: 0,
        AdUne2: 0,
        ClUne2: 0,
        MeUne2: 0,
        MeEe2: 0,
        ClEe2: 0,
        JeEe2: 0,
        AdEe2: 0,
        MeCe2: 0,
        AdCe2: 0,
        ClCe2: 0,
        JeCe2: 0,
        mes1: null,
        mes2: null,
        mes3: null,
        mes4: null,
        mes5: null,
        mds1: null,
        mds2: null,
        mds3: null,
        mds4: null,
        mds5: null,
      },
      pase: 0,
      section: "hoy",
      grupo: 0,
      questions: {
        hoy: {
          title: "Hoy",
          subtitle:
            "Estos seis primeros bloques debes responderlos pensando en qué es lo que mejor describe a la organización en este momento. Asigna el mayor número de puntos a la(s) descripción(es) que más caracteriza(n) a la organización actual.",
          grupos: [
            {
              text: "1.Características dominantes:",
              en: "1.Dominant Characteristics",
              questions: [
                {
                  codigo: "ClCd",
                  text: "La organización es un lugar muy acogedor. Es como una gran familia. Las personas comparten mucho de sí mismas.",
                },
                {
                  codigo: "MeCd",
                  text: "La organización está muy orientada a los resultados. Lo más importante es conseguir los objetivos. Las personas quieren ser las mejores y están orientadas al logro.",
                },
                {
                  codigo: "AdCd",
                  text: "La organización es un lugar dinámico y de iniciativas. La gente está dispuesta a arriesgarse.",
                },
                {
                  codigo: "JeCd",
                  text: "La organización es un lugar muy estructurado y con muchos controles y normas. La gente generalmente sigue los procedimientos formales.",
                },
              ],
            },
            {
              text: "2. Liderazgo organizacional",
              en: "2.Organizational Leadership",
              questions: [
                {
                  codigo: "JeLo",
                  text: "Por lo general, los líderes de la organización son ejemplo de control, orden y eficiencia.",
                },
                {
                  codigo: "ClLo",
                  text: "Por lo general, los líderes de la organización son ejemplo de acompañamiento, ayuda y cuidado de las personas.",
                },
                {
                  codigo: "MeLo",
                  text: "Por lo general, los líderes de la organización son ejemplo de practicidad, competitividad y orientación a resultados.",
                },
                {
                  codigo: "AdLo",
                  text: "Por lo general, los líderes de la organización son ejemplo de iniciativa, innovación y toma de riesgos.",
                },
              ],
            },
            {
              text: "3. Administración del personal",
              en: "3.Management of Employees",
              questions: [
                {
                  codigo: "AdAp",
                  text: "La administración del personal se caracteriza por promover la toma de riesgos, la innovación, la libertad y la diversidad. ",
                },
                {
                  codigo: "JeAp",
                  text: "La administración del personal se caracteriza por promover el cumplimiento de normas y el ajuste a los procedimientos y conductos regulares.",
                },
                {
                  codigo: "MeAp",
                  text: "La administración del personal se caracteriza por promover la alta exigencia,  el logro y ser los mejores. ",
                },
                {
                  codigo: "ClAp",
                  text: "La administración del personal se caracteriza por promover el trabajo en equipo, el consenso y la participación.",
                },
              ],
            },
            {
              text: "4. Los que nos une",
              en: "4.Organization Glue",
              questions: [
                {
                  codigo: "JeUne",
                  text: "Lo que nos mantiene unidos en la organización son las reglas y políticas establecidas. Hay que hacer las cosas como se debe. ",
                },
                {
                  codigo: "AdUne",
                  text: "Lo que nos mantiene unidos en la organización es el compromiso con la innovación y el desarrollo. Hay que estar un paso adelante. ",
                },
                {
                  codigo: "ClUne",
                  text: "Lo que nos mantiene unidos en la organización es la lealtad y la confianza mutua. El compromiso es alto.",
                },
                {
                  codigo: "MeUne",
                  text: "Lo que nos mantiene unidos en la organización son los retos y el cumplimiento de metas. Lo principal es cumplir los objetivos. ",
                },
              ],
            },
            {
              text: "5. Énfasis estratégico",
              en: "5.Strategic Emphases",
              questions: [
                {
                  codigo: "MeEe",
                  text: "La estrategia de la organización se enfoca en abrir y ganar mercado. Se valora la competitividad y el logro de metas.",
                },
                {
                  codigo: "ClEe",
                  text: "La estrategia de la organización se enfoca en el desarrollo de las personas.  Se valora la alta confianza, la apertura y participación.",
                },
                {
                  codigo: "JeEe",
                  text: "La estrategia de la organización se enfoca en la eficiencia y el cumplimiento de procedimientos.  Se valora hacer las cosas como está definido.",
                },
                {
                  codigo: "AdEe",
                  text: "La estrategia de la organización se enfoca en mantenerse actualizada y desarrollar cosas nuevas. Se valora probar distintas alternativas y buscar oportunidades.",
                },
              ],
            },
            {
              text: "6. Criterios de éxito",
              en: "6.Criteria of Success",
              questions: [
                {
                  codigo: "MeCe",
                  text: "Los indicadores de éxito en esta organización son abrir mercado y superar a la competencia.",
                },
                {
                  codigo: "AdCe",
                  text: "Los indicadores de éxito en esta organización son la innovación y tener productos únicos o los más novedosos. ",
                },
                {
                  codigo: "ClCe",
                  text: "Los indicadores de éxito en esta organización son el desarrollo, compromiso y bienestar de las personas y el  trabajo en equipo, .",
                },
                {
                  codigo: "JeCe",
                  text: "Los indicadores de éxito en esta organización son la eficiencia, la entrega confiable y el ajuste a procedimientos.",
                },
              ],
            },
          ],
        },
        futuro: {
          title: "FUTURO",
          subtitle:
            "Los siguientes seis bloques debes responderlos pensando en como debería ser la organización en cinco años para tener un éxito espectacular, lograr sus aspiraciones más altas, convertirse en un ejemplo sobresaliente de alto rendimiento, superar los objetivos establecidos actualmente o convertirse en el punto de referencia. Igualmente debes distribuir los 100 puntos otorgando más a aquella descripción(es) que piensas que es (son) clave para lo anterior.",
          grupos: [
            {
              text: "1. Características dominantes:",
              en: "1.Dominant Characteristics",
              questions: [
                {
                  codigo: "ClCd2",
                  text: "La organización es un lugar muy acogedor. Es como una gran familia. Las personas comparten mucho de sí mismas.",
                },
                {
                  codigo: "MeCd2",
                  text: "La organización está muy orientada a los resultados. Lo más importante es conseguir los objetivos. Las personas quieren ser las mejores y están orientadas al logro.",
                },
                {
                  codigo: "AdCd2",
                  text: "La organización es un lugar dinámico y de iniciativas. La gente está dispuesta a arriesgarse.",
                },
                {
                  codigo: "JeCd2",
                  text: "La organización es un lugar muy estructurado y con muchos controles y normas. La gente generalmente sigue los procedimientos formales.",
                },
              ],
            },
            {
              text: "2. Liderazgo organizacional",
              en: "2.Organizational Leadership",
              questions: [
                {
                  codigo: "JeLo2",
                  text: "Por lo general, los líderes de la organización son ejemplo de control, orden y eficiencia.",
                },
                {
                  codigo: "ClLo2",
                  text: "Por lo general, los líderes de la organización son ejemplo de acompañamiento, ayuda y cuidado de las personas.",
                },
                {
                  codigo: "MeLo2",
                  text: "Por lo general, los líderes de la organización son ejemplo de practicidad, competitividad y orientación a resultados.",
                },
                {
                  codigo: "AdLo2",
                  text: "Por lo general, los líderes de la organización son ejemplo de iniciativa, innovación y toma de riesgos.",
                },
              ],
            },
            {
              text: "3. Administración del personal",
              en: "3.Management of Employees",
              questions: [
                {
                  codigo: "AdAp2",
                  text: "La administración del personal se caracteriza por promover la toma de riesgos, la innovación, la libertad y la diversidad. ",
                },
                {
                  codigo: "JeAp2",
                  text: "La administración del personal se caracteriza por promover el cumplimiento de normas y el ajuste a los procedimientos y conductos regulares.",
                },
                {
                  codigo: "MeAp2",
                  text: "La administración del personal se caracteriza por promover la alta exigencia,  el logro y ser los mejores. ",
                },
                {
                  codigo: "ClAp2",
                  text: "La administración del personal se caracteriza por promover el trabajo en equipo, el consenso y la participación.",
                },
              ],
            },
            {
              text: "4. Los que nos une",
              en: "4.Organization Glue",
              questions: [
                {
                  codigo: "JeUne2",
                  text: "Lo que nos mantiene unidos en la organización son las reglas y políticas establecidas. Hay que hacer las cosas como se debe. ",
                },
                {
                  codigo: "AdUne2",
                  text: "Lo que nos mantiene unidos en la organización es el compromiso con la innovación y el desarrollo. Hay que estar un paso adelante. ",
                },
                {
                  codigo: "ClUne2",
                  text: "Lo que nos mantiene unidos en la organización es la lealtad y la confianza mutua. El compromiso es alto.",
                },
                {
                  codigo: "MeUne2",
                  text: "Lo que nos mantiene unidos en la organización son los retos y el cumplimiento de metas. Lo principal es cumplir los objetivos. ",
                },
              ],
            },
            {
              text: "5. Énfasis estratégico",
              en: "5.Strategic Emphases",
              questions: [
                {
                  codigo: "MeEe2",
                  text: "La estrategia de la organización se enfoca en abrir y ganar mercado. Se valora la competitividad y el logro de metas.",
                },
                {
                  codigo: "ClEe2",
                  text: "La estrategia de la organización se enfoca en el desarrollo de las personas.  Se valora la alta confianza, la apertura y participación.",
                },
                {
                  codigo: "JeEe2",
                  text: "La estrategia de la organización se enfoca en la eficiencia y el cumplimiento de procedimientos.  Se valora hacer las cosas como está definido. ",
                },
                {
                  codigo: "AdEe2",
                  text: "La estrategia de la organización se enfoca en mantenerse actualizada y desarrollar cosas nuevas. Se valora probar distintas alternativas y buscar oportunidades.",
                },
              ],
            },
            {
              text: "6. Criterios de éxito",
              en: "6.Criteria of Success",
              questions: [
                {
                  codigo: "MeCe2",
                  text: "Los indicadores de éxito en esta organización son abrir mercado y superar a la competencia.",
                },
                {
                  codigo: "AdCe2",
                  text: "Los indicadores de éxito en esta organización son la innovación y tener productos únicos o los más novedosos. ",
                },
                {
                  codigo: "ClCe2",
                  text: "Los indicadores de éxito en esta organización son el desarrollo, compromiso y bienestar de las personas y el  trabajo en equipo, .",
                },
                {
                  codigo: "JeCe2",
                  text: "Los indicadores de éxito en esta organización son la eficiencia, la entrega confiable y el ajuste a procedimientos.",
                },
              ],
            },
          ],
        },
      },
    };
  },
  computed: {
    total() {
      const _this = this;
      const codigoscuestions = [];
      let total = 0;
      for (let index in this.questions[this.section].grupos[this.grupo]
        .questions) {
        const cod =
          this.questions[this.section].grupos[this.grupo].questions[index]
            .codigo;
        codigoscuestions.push(cod);
      }
      for (let index1 in codigoscuestions) {
        const cod1 = codigoscuestions[index1];
        let number = isNaN(parseInt(_this.responses[cod1]))
          ? 0
          : parseInt(_this.responses[cod1]);

        if (number < 0) {
          number = 0;
        }
        total += number;
      }
      if (isNaN(total)) {
        total = 0;
      }
      return total;
    },
    validatotal() {
      if (this.total === 100) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    async findresponded() {
      try {
        const result = await apiServices.get(
          `/employeerespondedcultura/${this.$route.params.id}`
        );
        if (result.data) {
          if (result.data.message) {
            this.$store.dispatch("notify", {
              message: result.data.message,
              type: "is-danger",
              duration: 4000,
              position: "top-center",
            });
            setTimeout(function () {
              window.location.replace("https://sietegho.com");
            }, 5000);
          } else {
            if (result.data.status === "Terminada") {
              this.pase = 5;
              setTimeout(function () {
                window.location.replace("https://sietegho.com");
              }, 5000);
            } else {
              this.employeeresponded = result.data;
              this.section = result.data.encuesta
                ? result.data.encuesta.section
                : "hoy";
              this.pase = result.data.encuesta ? result.data.encuesta.pase : 0;
              this.grupo = result.data.encuesta
                ? result.data.encuesta.grupo
                : 0;
              if (result.data.responses) {
                this.responses = result.data.responses;
              }
            }
          }
        }
      } catch (err) {
        console.log(err);
        this.pase = 6
        await this.$store.dispatch("notify", {
          message: 'Error - Esta encuesta no existe o sucedio otro problema.',
          type: "is-danger",
          duration: 4000,
          position: "top-center",
        });
        setTimeout(function () {
          window.location.replace("https://sietegho.com");
        }, 2300);
      }
    },
    async savecustions(end) {
      try {
        const d = {
          id: this.$route.params.id,
          responses: this.responses,
          encuesta: {
            pase: this.pase,
            section: this.section,
            grupo: this.grupo,
          },
        };
        if (end) {
          d.end = true;
        }
        await apiServices.post(`/saveresponsescultura`, d);
        if (end) {
          setTimeout(function () {
            window.location.replace("https://sietegho.com");
          }, 5000);
        }
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message:
            "Ocurrio un error guardando las respuestas. Inténtelo mas tarde.",
          type: "is-danger",
          position: "top-center",
        });
      }
    },
    blurFunction(codigo) {
      let number = this.responses[codigo];
      number = isNaN(parseInt(this.responses[codigo]))
        ? 0
        : parseInt(this.responses[codigo]);
      if (number < 0) {
        number = 0;
      }
      if (number > 100) {
        number = 100;
      }
      this.responses[codigo] = number;
    },
    nextpase1() {
      this.pase = 4;
      this.savecustions();
    },
    nextpase(end) {
      console.log("ejecuta el next pase");
      if (this.pase === 4) {
        this.pase = 5;
        this.savecustions(true);
      } else if (!this.responses.agree) {
        this.pase = 5;
        this.savecustions();
      } else if (end) {
        this.pase = 5;
        this.savecustions(true);
      } else {
        this.pase++;
        this.savecustions();
      }
    },
    nextquestion(end) {
      const _this = this;
      for (let index in this.questions[this.section].grupos[this.grupo]
        .questions) {
        const cod =
          this.questions[this.section].grupos[this.grupo].questions[index]
            .codigo;
        _this.blurFunction(cod);
      }
      if (this.total === 100) {
        if (this.grupo === 5 && this.section === "hoy") {
          if (parseInt(this.employeeresponded.quiz) === 3) {
            this.grupo = 0;
            this.section = "futuro";
          }
          if (parseInt(this.employeeresponded.quiz) === 2) {
            this.pase++;
          }
          if (parseInt(this.employeeresponded.quiz) === 1) {
            this.pase = 5;
            this.savecustions();
            return false;
          }
        } else if (this.grupo === 5 && this.section === "futuro") {
          if (parseInt(this.employeeresponded.quiz) === 3) {
            this.pase++;
          } else {
            this.pase = 5;
            this.savecustions();
            return false;
          }
        } else {
          this.grupo++;
        }
        this.savecustions(end);
      } else {
        this.$store.dispatch("notify", {
          message: "El total debe sumar 100",
          type: "is-warning",
          duration: 4000,
          position: "top-center",
        });
      }
    },
    backpase(){
      this.pase--
    }
  },
  created() {
    this.findresponded();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cultura/Encuestacultura.vue